import "./Contact.css";
import { FaLeaf, FaFacebook, FaInstagram } from "react-icons/fa";

function Contact() {
    return (
        <section className="contact-section" id="contact">

            <div className="contact-container">

                {/* Logo */}
                <div className="contact-logo">
                    <FaLeaf className="leaf-icon" />
                    <h1>Thai Nursery</h1>
                </div>

                {/* Contact Details */}
                <div className="contact-details">

                    <div className="contact-box">
                        <h2>FOR CONTACT</h2>

                        <p><strong>Phone:</strong> 9626670471</p>
                        <p><strong>Whatsapp:</strong> 9626670471</p>
                    </div>

                    <div className="contact-box">
                        <h2>Business Hours</h2>

                        <p>Monday - Friday : 9 AM - 6 PM</p>
                        <p>Saturday : 9 AM - 12 PM</p>
                    </div>

                </div>

            </div>

            {/* Social */}
            <div className="social-section">

                <h2>Get Social</h2>

                <div className="social-icons">

                    <a
                        href=""
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FaFacebook />
                    </a>

                    <a
                        href=""
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FaInstagram />
                    </a>

                </div>

            </div>

        </section>
    );
}

export default Contact;